import { AfterContentInit, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';


@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit, AfterContentInit {

    @Input() tabs = [];
    @Input() autorouting = true;

    @Output() tabClicked = new EventEmitter();

    @HostBinding('class.material') @Input() material = true;

    ngAfterContentInit(): void {
    }

    constructor() {
    }

    ngOnInit() {
    }


    tabClick(clickedTab: any) {
        const newtabs = this.tabs.map(tab => ({
            ...tab,
            active: tab.link === clickedTab.link
        }));

        this.tabClicked.emit(newtabs);
    }
}
